module.exports = __webpack_public_path__ + "img/Top-Users-by-Centrality-Rank-400x250.809b7d63.png";